import Vue from 'vue'
import Router, {RouteConfig} from 'vue-router'
import Layout from '@/layout/index.vue'
import Login from '@/views/account/login.vue';
//import activityRouter from './modules/activity'
import cardRouter from './modules/cards'
import cmsRouter from './modules/cms'
import paysRouter from './modules/pays'
import projectRouter from './modules/projects'
import questionRouter from './modules/questions'
import organizationRouter from './modules/organization'
import activityRouter from './modules/activity'
import auditsRouter from './modules/audits'
import settingsRouter from './modules/settings'
import protocolRouter from './modules/protocols'
import profitReportRouter from './modules/report'
import topAdminRouter from './modules/topAdminRouter'
import incomeRecordRouter from './modules/incomeRecord';
import {UserState} from "@/store/modules/user";
import store from '@/store/index'

Vue.use(Router)

/*
  redirect:                      if set to 'noredirect', no redirect action will be trigger when clicking the breadcrumb
  meta: {
    title: 'title'               the name showed in subMenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon showed in the sidebar
    breadcrumb: false            if false, the item will be hidden in breadcrumb (default is true)
    hidden: true                 if true, this route will not show in the sidebar (default is false)
  }
*/

export const constantRoutes: RouteConfig[] = [
  {
    path: '/selectStore',
    component: () => import(/* webpackChunkName: "login" */ '@/views/selectStore.vue'),
    meta: {
      title: '选择门店',
      hidden: true,
      requireOu: false
    }
  },
  {
    path: '/redirect',
    component: Layout,
    meta: {hidden: true, requireOu: false, auth: false},
    children: [{
      path: '/redirect/:path(.*)',
      component: () => import(/* webpackChunkName: "redirect" */ '@/views/redirect/index.vue')
    }]
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
    meta: {hidden: true, requireOu: false, auth: false}
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    meta: {
      title: 'Dashboard',
      auth: false,
    },
    children: [
      {
        path: 'dashboard',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/index.vue'),
        meta: {
          title: 'Dashboard',
        }
      },
      {
        path: 'dashboard-store',
        name: 'dashboard-store',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/store.vue'),
        meta: {
          title: '门店报表'
        }
      },
      {
        path: 'dashboard-headquarters',
        name: 'dashboard-headquarters',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/headquarters.vue'),
        meta: {
          title: '总部报表'
        }
      },
      {
        path: 'dashboard-region',
        name: 'dashboard-region',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/region.vue'),
        meta: {
          title: '大区报表'
        }
      },
      {
        path: 'dashboard-district',
        name: 'dashboard-district',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/district.vue'),
        meta: {
          title: '片区报表'
        }
      }
    ]
  }
  ,
  {
    path: '/myAudit',
    component: Layout,
    redirect: '/myAudit/myAudit',
    meta: {
      title: '我的审核列表'
    },
    children: [
      {
        path: 'myAudit',
        name: 'myAudit',
        component: () => import(/* webpackChunkName: "audit-my" */ '@/views/audits/myAudit.vue'),
        meta: {
          title: '我的审核列表'
        }
      },
      {
        path: 'myAuditLogs',
        name: 'myAuditLogs',
        component: () => import(/* webpackChunkName: "audit-my" */ '@/views/audits/myAuditLog.vue'),
        meta: {
          title: '我审核的记录'
        }
      }
    ]
  },
  {
    path: '/account/login',
    name:'login',
    component: Login,
    meta: {
      title: '登录',
      auth: false
    },


  },

]

// 动态加载菜单
export const asyncRouter: RouteConfig[] = [

  {
    path: '/admin',
    component: Layout,
    redirect: '/admin/audits',
    name: '管理',
    meta: {
      title: '管理'
    },
    children: [
      {
        path: 'userList',
        name: 'userList',
        component: () => import(/* webpackChunkName: "admin-user" */ '@/views/admin/userList.vue'),
        meta: {
          title: '用户管理'
        }
      },
      {
        path: 'user-detail/:id',
        name: 'user-detail',
        component: () => import(/* webpackChunkName: "admin-user" */ '@/views/admin/user/detail.vue'),
        meta: {
          title: '用户详情'
        },
      },
      {
        path: 'permissionDefinition',
        name: 'permissionDefinition',
        component: () => import(/* webpackChunkName: "admin-permission" */ '@/views/admin/permission/definition/index.vue'),
        meta: {
          title: '权限定义'
        }
      },
      {
        path: 'roles',
        name: '角色管理',
        component: () => import(/* webpackChunkName: "admin-role" */ '@/views/admin/roleList.vue'),
        meta: {
          title: '角色管理'
        }
      },
      {
        path: 'tenantList',
        name: '租户管理',
        component: () => import(/* webpackChunkName: "admin-tenant" */ '@/views/admin/tenant/list.vue'),
        meta: {
          title: '租户管理'
        }
      },
      {
        path: 'audits',
        name: '操作日志',
        component: () => import(/* webpackChunkName: "admin-audit-logs" */'@/views/admin/AuditLogList.vue'),
        meta: {
          title: '操作日志'
        }
      },
      {
        path: 'adSwiper',
        name: 'adSwiper',
        component: () => import(/* webpackChunkName: "cms" */'@/views/admin/SwiperList.vue'),
        meta: {
          title: '滚动广告'
        }
      },
      {
        path: 'userPointLog_list',
        name: 'userPointLog_list',
        component: () => import(/* webpackChunkName: "admin-user-point-logs" */'@/views/users/userPointLog_list.vue'),
        meta: {
          title: '用户积分明细'
        }
      }
    ]
  },
  organizationRouter,
  activityRouter,
  cmsRouter,
  cardRouter,
  paysRouter,
  projectRouter,
  questionRouter,
  auditsRouter,
  //workflowRouter,
  {
    path: '*',
    redirect: '/404',
    meta: {hidden: true}
  },
  protocolRouter,
  profitReportRouter,
  topAdminRouter,
  settingsRouter,
  incomeRecordRouter

]

const router = new Router({
  // mode: 'history',  // Enable this if you need.
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  },
  base: process.env.BASE_URL,
  routes: [...constantRoutes, ...asyncRouter]
});

router.beforeEach(((to, from, next) => {

  console.log('auth beforeEach:', to)
  const user = store.state.user
  if ((to.meta as any).auth === false) {
    // 如果不需要验证，则直接跳转。（默认情况是需要验证的）
    next();
  } else if(!(user?.token)){
    // 如果没有token，则视为未登录，跳转到登录页面
    next({path:'/account/login'});
  } else {
    const ouId = user?.ou?.id;
    if (ouId !== -999) {
      // 如果有ouId，则视为已经选择了门店，直接跳转
      next();
    } else {
      if ((to.meta as any).requireOu !== false) {
        // 如果没有ouId，则视为未选择门店，跳转到选择门店页面
        next({path: '/selectStore'})
      } else {
        next();
      }
    }
  }




}))

export default router;
